import React, { useContext, useEffect, useState } from 'react';
import { Tabs, Tag } from 'antd'; // Import Tabs from Ant Design
import CpnDongTienLai from '../item_menu/CpnDongTienLai';
import CpnDongHD from '../item_menu/CpnDongHD';
import moment from 'moment';
import CpnLichSu from '../item_menu/CpnLichSu';
import { FaMoneyBillWave, FaCamera, FaCalendarAlt, FaFileContract, FaArrowUp, FaPlus, FaClock, FaFileInvoice, FaHistory, FaExclamationCircle } from 'react-icons/fa'; // Thêm các icon bạn muốn sử dụng

// import ModalContext from './../../ModalContext'; // Đảm bảo đường dẫn đúng

export default function TabCpn({tab, id}) {

    const [name, setName] = useState('');
    const [totalMoney, setTotalMoney] = useState('');
    const [rate, setRate] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [totalInterest, setTotalInterest] = useState('');
    const [interestMoneyReceived, setInterestMoneyReceived] = useState('');
    const [debitMoney, setDebitMoney] = useState('');
    const [status, setStatus] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('token'); // Thay 'your_token_key' bằng key thực tế
        fetch(`${process.env.REACT_APP_API_DB_URL}/loan-credit/${id}`,
            {
                method: 'GET', // Hoặc 'POST' nếu cần thiết
                headers: {
                    'Authorization': `Bearer ${token}`, // Thêm token vào headers
                    'Content-Type': 'application/json' // Nếu cần
                }
            })
            .then(response => response.json())
            .then(data => {
                setName(data.NAME)
                setTotalMoney(data.TOTAL_MONEY);
                setRate(data.RATE);
                const formattedDate = moment(data.FROM_DATE).format('DD-MM-YYYY');
                setFromDate(formattedDate);
                setTotalInterest(data.TOTAL_INTEREST);
                setInterestMoneyReceived(data.INTEREST_MONEY_RECEIVED);
                setDebitMoney(data.DEBIT_MONEY);
                setStatus(data.STR_STATUS);
            })
            .catch(error => console.error('Error fetching data:', error))
    }, []);

    return (
        <div className="max-h-[90vh] overflow-y-auto">
            <div className="bg-white p-1 rounded-lg shadow-lg">
                <h1 className="text-xl font-bold mb-4">
                    Bảng chi tiết Hợp đồng vay tiền <span className="font-bold">TC-{id}</span>
                </h1>

                {/* Responsive Grid cho bảng thông tin khách hàng */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                        <table className="w-full">
                            <tbody>
                                <tr>
                                    <td className="font-bold">Khách hàng</td>
                                    <td className="font-bold">{name}</td>
                                </tr>
                                <tr>
                                    <td className="font-bold">Tiền vay</td>
                                    <td>{totalMoney.toLocaleString('vi-VN') } VNĐ</td>
                                </tr>
                                <tr>
                                    <td className="font-bold">Lãi suất</td>
                                    <td>{rate} k /1triệu</td>
                                </tr>
                                <tr>
                                    <td className="font-bold">Vay từ ngày</td>
                                    <td>{fromDate}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <table className="w-full">
                            <tbody>
                                <tr>
                                    <td className="font-bold">Tổng lãi</td>
                                    <td>{totalInterest.toLocaleString('vi-VN') } VNĐ</td>
                                </tr>
                                <tr>
                                    <td className="font-bold">Đã thanh toán</td>
                                    <td>{interestMoneyReceived.toLocaleString('vi-VN') } VNĐ</td>
                                </tr>
                                <tr>
                                    <td className="font-bold">Nợ cũ</td>
                                    <td className="text-red-500">{debitMoney.toLocaleString('vi-VN') } VNĐ</td>
                                </tr>
                                
                                <tr>
                                    <td className="font-bold">Trạng thái</td>
                                    <td>
                                    <Tag color={status === 'Nợ lãi' ? '#fcba03' : (status === 'Quá hạn' ? '#F4516C' :'#108ee9')}>{status}</Tag>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <Tabs defaultActiveKey={tab}>
                    <Tabs.TabPane
                        tab={
                            <div className='flex items-center space-x-2'>
                                <FaCamera />
                                <span>Đóng tiền lãi</span>
                            </div>
                        }
                        key="1"
                    >
                        <CpnDongTienLai loanIdPayment={id}/>
                    </Tabs.TabPane>
                   
                    <Tabs.TabPane
                        tab={
                            <div className='flex items-center space-x-2'>
                                <FaFileContract />
                                <span>Đóng HĐ</span>
                            </div>
                        }
                        key="5"
                    >
                        <CpnDongHD loanId={id}/>
                    </Tabs.TabPane>
                    <Tabs.TabPane
                        tab={
                            <div className='flex items-center space-x-2'>
                                <FaHistory />
                                <span>Lịch sử</span>
                            </div>
                        }
                        key="6"
                    >
                        <CpnLichSu loanId={id}/>
                    </Tabs.TabPane>
                </Tabs>
            </div>
        </div>
    );
}
